import { render } from "./ProjectThumb.vue?vue&type=template&id=cbd7a3b4&scoped=true"
import script from "./ProjectThumb.vue?vue&type=script&lang=js"
export * from "./ProjectThumb.vue?vue&type=script&lang=js"

import "./ProjectThumb.vue?vue&type=style&index=0&id=cbd7a3b4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cbd7a3b4"

export default script